import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

type Props = {
  isLoading?: boolean;
  size?: number;
};

/**
 * Shared loading indicator.
 * Renders a centred MUI spinner while `isLoading` is truthy.
 */
const Loading: React.FC<Props> = ({ isLoading = true, size = 32 }) => {
  if (!isLoading) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 2,
      }}
    >
      <CircularProgress size={size} color="primary" />
    </Box>
  );
};

export default Loading;
